import { create } from "zustand";

const modalStore = create((set) => ({
  isDisclosureOpen: false,
  openDisclosure: () => set({ isDisclosureOpen: true }),
  closeDisclosure: () => set({ isDisclosureOpen: false }),
}));

export default modalStore;
